import { Spinner } from "@components/ui-kit";
import { NotFoundRFI } from "@components/widgets/ErrorPage";
import { useRequestForInvoicingQuery } from "@src/__generated__/graphql";
import { useStore } from "@src/utils/hooks";
import { FormMode } from "@src/utils/types";
import { observer } from "mobx-react-lite";
import { type FunctionComponent, useState } from "react";
import { Container } from "../components";
import { InvoiceStore, InvoiceStoreContext, InvoiceTypeEnum } from "../store";

interface EditRFIProps {
  id: string;
}

export const EditRFI: FunctionComponent<EditRFIProps> = observer(
  function EditRFI({ id }) {
    const appStore = useStore();
    const [store] = useState(
      () =>
        new InvoiceStore(
          appStore,
          true,
          InvoiceTypeEnum.CreditNote,
          FormMode.EDIT,
        ),
    );

    const { data, loading } = useRequestForInvoicingQuery({
      variables: { id },
      skip: !id,
      onCompleted({ requestForInvoicing }) {
        if (!requestForInvoicing) return;

        store.setDataFromRFI(requestForInvoicing);
      },
    });

    if (loading) {
      return <Spinner absolute />;
    }

    if (!data?.requestForInvoicing) {
      return <NotFoundRFI />;
    }

    if (!store.invoice_id) {
      return null;
    }

    return (
      <InvoiceStoreContext.Provider value={store}>
        <Container />
      </InvoiceStoreContext.Provider>
    );
  },
);
